import { jsx as _jsx } from "react/jsx-runtime";
import { ManageMentorship } from 'src/modules/mentorship/components/manageMentorship';
export function Mentorship() {
    return _jsx(ManageMentorship, {});
}
